import { CountryCode } from '../shopify/types/admin.types';
import countriesData from '../data/countries.json';

export interface Country {
  code: string;
  name: string;
}

// Convert the countries.json data into a format that matches CountryCode
const rawCountries = Object.entries(countriesData).map(([code, data]) => ({
  code: code.toUpperCase(),
  name: (data as { name: string }).name
}));

// Create a map of CountryCode values to their string representations
const shopifyCountryCodes = Object.values(CountryCode).map(code => code.toString());

// Filter and sort countries that exist in both sources
export const countries: Country[] = rawCountries
  .filter(country => shopifyCountryCodes.includes(country.code))
  .sort((a, b) => a.code.localeCompare(b.code));

// Helper function to get country name by code
export const getCountryName = (code: string): string | undefined => {
  const country = countries.find(c => c.code === code.toUpperCase());
  return country?.name;
};

// Helper function to validate if a country code exists
export const isValidCountryCode = (code: string): boolean => {
  return countries.some(c => c.code === code.toUpperCase());
}; 